import gql from 'graphql-tag';

export const ALTERNATE_BILLING_FRAGMENT = gql`
  fragment AlternateBillingFragment on BillingInfo {
    companyName
    contactName
    address1
    address2
    city
    state
    zip
    country
  }
`;
